export const emotions = {
    regret: {label: 'Regret', color: '#008FFB', attenuationHours: 3},
    hate: {label: 'Haine', color: '#FF0000', attenuationHours: 24},
    distress: {label: 'Détresse', color: '#FEB019', attenuationHours: 24},
    fear: {label: 'Peur', color: '#FF4560', attenuationHours: 0.7},
    sadness: {label: 'Tristesse', color: '#775DD0', attenuationHours: 120},
    shame: {label: 'Honte', color: '#3f51b5', attenuationHours: 0.5},
    loathing: {label: 'Aversion', color: '#03a9f4', attenuationHours: 24},
    disgust: {label: 'Dégoût', color: '#4caf50', attenuationHours: 0.5},
    guilt: {label: 'Culpabilité', color: '#f9ce1d', attenuationHours: 3.5},
    anger: {label: 'Colère', color: '#FF9800', attenuationHours: 2},
    frustration: {label: 'Frustration', color: '#5C4742', attenuationHours: 3},
    pride: {label: 'Fierté', color: '#2b908f', attenuationHours: 2.6},
    love: {label: 'Amour', color: '#f9a3a4', attenuationHours: 24},
    relief: {label: 'Soulagement', color: '#90ee7e', attenuationHours: 5},
    joy: {label: 'Joie', color: '#69d2e7', attenuationHours: 35},
    hope: {label: 'Espoir', color: '#fa4443', attenuationHours: 24},
};

export const compareEmotions = (a, b) => {
    const c = new Intl.Collator();
    return c.compare(emotions[a]?.label, emotions[b]?.label);
};

export default emotions;
